// Packages
import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

// Actions
//import { setEditEntry } from "components/Stacker/actions/CartActions"
import { metalSelected } from "components/Stacker/actions/ProductDetailActions"
import { refineMetal } from "components/Stacker/actions/StackerActions"
//import { setStackedMetal } from "components/Stacker/actions/StackItWithActions"
// Components
import ToolTip from "components/Stacker/components/ToolTip/ToolTip"
import LinkAdapter from "components/Stacker/components/LinkAdapter/LinkAdapter"

// Styles
import "./MetalSwatch.scss"

import { useDispatch } from "react-redux"

function MetalSwatch(props) {
  const dispatch = useDispatch()
  // const setMetalPid = () => {
  //   const {
  //     baseCode,
  //     productCode,
  //     //entryNumber,
  //     dispatch,
  //     isSelected,
  //     //isEditCart,
  //     isStackedProduct,
  //   } = props

  //   // if (isSelected !== "true" && isEditCart) {
  //   //   dispatch(setEditEntry({ entryNumber, baseProductID: productCode }))
  //   // }
  //   if (isSelected !== "true" && isStackedProduct) {
  //     dispatch(
  //       setStackedMetal({ metalCode: productCode, stackedCode: baseCode })
  //     )
  //   }
  // }

  const handleMetalSelection = () => {
    const { productCode, refinerId, url } = props
    if (refinerId) {
      dispatch(
        refineMetal({
          data: { variantCode: productCode, refinerId },
          retailerId: props.retailerId,
        })
      )
    } else {
      const pdpUrl = `${url}.pdp.html`
      dispatch(metalSelected(productCode, pdpUrl))
    }
  }

  const renderMetalUI = () => {
    const {
      metalImage,
      url,
      isSelected,
      productName,
      metalVariantCode,
      isLink,
      metalVariantName,
    } = props
    const pdpUrl = `${url}.pdp.html`
    if (isLink) {
      return (
        <LinkAdapter
          className={classNames("metal-swatch-link", {
            selected: isSelected === "true",
          })}
          to={pdpUrl}
          baseProduct={metalVariantCode}
          aria={{ label: metalVariantName }}
          customClick={handleMetalSelection}
        >
          <span className="wrapper d-flex justify-content-center">
            <span className="image-wrapper d-flex align-items-center justify-content-center">
              <img
                src={metalImage}
                className="metal-swatch-image"
                alt={`${productName} - ${metalVariantName}`}
              />
            </span>
          </span>
        </LinkAdapter>
      )
    }
    return (
      <button
        className={classNames("metal-swatch-link", {
          selected: isSelected === "true",
        })}
        onClick={handleMetalSelection}
      >
        <span className="wrapper d-flex justify-content-center">
          <span className="image-wrapper d-flex align-items-center justify-content-center">
            <img
              src={metalImage}
              className="metal-swatch-image"
              alt={`${productName} - ${metalVariantName}`}
            />
          </span>
        </span>
      </button>
    )
  }

  const { metalVariantName, showTooltip } = props

  return (
    <li
      className={classNames("MetalSwatch", {
        "metal-swatch-tooltip": showTooltip,
      })}
    >
      {renderMetalUI()}
      {showTooltip && <ToolTip tooltipText={metalVariantName} />}
    </li>
  )
}

MetalSwatch.propTypes = {
  baseCode: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  entryNumber: PropTypes.string,
  isEditCart: PropTypes.bool,
  isLink: PropTypes.bool,
  isSelected: PropTypes.string.isRequired,
  isStackedProduct: PropTypes.bool,
  metalImage: PropTypes.string.isRequired,
  metalVariantCode: PropTypes.string.isRequired,
  metalVariantName: PropTypes.string.isRequired,
  productCode: PropTypes.string,
  productName: PropTypes.string,
  refinerId: PropTypes.string,
  showTooltip: PropTypes.bool,
  url: PropTypes.string.isRequired,
  retailerId: PropTypes.string,
}

export default MetalSwatch
